import api from '../../plugins/api';

const removeService = ({ id }) => {
  return api.post('api/crm/additional-services/removeAdditionalService', { id });
};

export default removeService;
